var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    attrs: {
      clearable: "",
      disabled: _vm.disabled,
      minlength: _vm.minLength,
      maxlength: _vm.maxLength,
      type: _vm.type
    },
    on: { change: _vm.onChanged, input: _vm.onInput },
    model: {
      value: _vm.text,
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }